module.exports = __webpack_public_path__ + "img/donatecertificate.0f0dbea7.png";